module.exports = __webpack_public_path__ + "static/img/commercial-terms-2.bf4868d4.png";